import type { JSONRPCAPI } from '@phi/frontend/api/provider';

export type AuthenticationAPI = ReturnType<typeof auth_api_factory>;

export const auth_api_factory = (api: JSONRPCAPI) => ({
    sign_up: api.helper('sign_up'),
    phi_log_in: api.helper('authenticate_through_phi'),
    forgot_my_password: api.helper('forgot_my_password'),
    validate_session: api.helper('validateSession'),
});
